import { Bell } from 'lucide-react';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerTitle,
  DrawerDescription,
} from '@components/ui/drawer';
import { Button } from '@components/ui/button';
import type { UseWebPushPermissionPromptReturn } from '@hooks/useWebPushPermissionPrompt';
import { useAmplitudeTracking } from '@hooks/useAmplitudeTracking';
import { ANALYTICS_EVENTS } from '@lib/analytics-events';

interface WebPushPermissionDrawerProps {
  prompt: UseWebPushPermissionPromptReturn;
}

export function WebPushPermissionDrawer({ prompt }: WebPushPermissionDrawerProps) {
  const { trackEvent } = useAmplitudeTracking();

  return (
    <Drawer
      open={prompt.isOpen}
      // eslint-disable-next-line @typescript-eslint/no-empty-function -- intentional: button-only dismiss
      onOpenChange={() => {}}
      dismissible={false}
    >
      <DrawerContent hideHandle>
        <DrawerHeader>
          <div className="flex justify-center mb-2">
            <Bell className="h-8 w-8 text-mb-yellow" />
          </div>
          <DrawerTitle>Want to know when people respond?</DrawerTitle>
          <DrawerDescription>
            Get notified when someone replies to your posts, sends a message, or interacts with you,
            even when meetball is closed.
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter>
          <Button
            onClick={() => void prompt.handleEnable()}
            disabled={prompt.isEnabling}
            className="bg-mb-yellow hover:bg-mb-yellow text-black font-semibold rounded-full px-8
              w-full h-12 shadow-glow-yellow transition-all duration-200"
          >
            {prompt.isEnabling ? 'Enabling...' : 'Enable Notifications'}
          </Button>
          <Button
            variant="outline"
            onClick={() => {
              trackEvent(ANALYTICS_EVENTS.cta_clicked, {
                cta_name: 'web_push_maybe_later',
                source_context: 'web_push_permission_drawer',
              });
              prompt.handleDismiss();
            }}
          >
            Maybe Later
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
